import React, { useState, useCallback, useEffect } from 'react'
import {
  LegacyCard,
  LegacyFilters,
  DataTable,
  Toast,
  Button,
  Link,
  LegacyTabs,
} from '@shopify/polaris'
import { useDispatch, useSelector } from 'react-redux'
import BookingActions from 'Redux/BookingRedux'
import Loader from 'Components/Loader'
import moment from 'moment'
import { ItemsPerPage } from 'Redux/genericReducers'
import AppointoPagination from 'Components/AppointoPagination'
import useDebounce from 'Hooks/debounce'

let headings = ['Order No.', 'Team Member', 'Service Name', 'Service Time', '']

const CustomerSettings = (props) => {
  const dispatch = useDispatch()
  const [bookings, setBookings] = useState([])
  const [queryValue, setQueryValue] = useState('')
  const [selected, setSelected] = useState(0)
  const debouncedQueryValue = useDebounce(queryValue, 300)
  const settingsData = useSelector((state) => state.settings.data)

  useEffect(() => {
    dispatch(BookingActions.bookingsListRequest({ status: 'upcoming' }))
  }, [dispatch])

  const bookingsList = useSelector((state) => state.booking.list)
  const bookingsFetching = useSelector((state) => state.booking.listFetching)
  const listDataOffset = useSelector((state) => state.booking.listDataOffset)

  const filters = []
  const appliedFilters = []

  useEffect(() => {
    if (
      bookingsList.length > 0 &&
      !props.isWeb &&
      !settingsData.review_modal_shown
    ) {
      setShowReviewModal(true)
    }
  }, [bookingsList])

  const formatBookingsList = (bookingsList) => {
    return renderBookingsView(bookingsList)
  }

  const renderBookingsView = (bookingsList) => {
    return bookingsList.map((o) => {
      let values = []
      headings.map((h) => {
        let content = ''
        switch (h) {
          case 'Order No.':
            content =
              (props.isWeb &&
                settingsData.team_member_setting.hide_order_number) ||
              o.order_name === '-' ? (
                <p className="exclude-translation notranslate">-</p>
              ) : (
                <div className="exclude-translation notranslate">
                  {o.order_name}
                </div>
              )
            break
          case 'Team Member':
            content = (
              <p className="exclude-translation notranslate">
                {o.team_member ? o.team_member.name : 'Admin'}
              </p>
            )
            break
          case 'Service Name':
            content = (
              <div className="exclude-translation notranslate">
                <p>{o.product_name}</p>
                {o.variant_name && (
                  <p style={{ fontSize: '0.8em', color: 'gray' }}>
                    {o.variant_name}
                  </p>
                )}
              </div>
            )
            break
          case 'Service Time':
            content =
              o.scenario === 'multi_day' ? (
                <div className="exclude-translation">
                  <p>{`${moment(o.start_date).format('MMM Do YYYY')} - ${moment(
                    o.end_date
                  ).format('MMM Do YYYY')}`}</p>
                  <p style={{ fontSize: '0.8em', color: 'gray' }}>
                    Number of days: {o.quantity} days
                  </p>
                </div>
              ) : (
                <div className="exclude-translation">
                  <p>{moment(o.selected_time).format('llll')}</p>
                  <p style={{ fontSize: '0.8em', color: 'gray' }}>
                    Duration: {o.duration} mins
                  </p>
                </div>
              )
            break
          default:
            content = (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                }}
              >
                <Button onClick={viewDetails(o)} variant="primary">
                  Manage Booking
                </Button>
              </div>
            )
            break
        }
        values.push(content)
      })
      return values
    })
  }
  const allBookings = formatBookingsList(bookingsList)

  useEffect(() => {
    setBookings(allBookings)
  }, [bookingsList])

  const handleQueryValueRemove = useCallback(() => {
    setQueryValue('')
    dispatch(BookingActions.bookingsListRequest({}, 0))
  }, [allBookings])
  const handleFiltersClearAll = useCallback(() => {
    handleQueryValueRemove()
  }, [handleQueryValueRemove])

  const handleFiltersQueryChange = useCallback((value) => {
    setQueryValue(value)
  }, [])

  useEffect(() => {
    if (queryValue.length >= 3) {
      dispatch(
        BookingActions.bookingsListRequest(
          {
            search_term: queryValue,
          },
          0
        )
      )
    }
    if (queryValue.length == 0) {
      dispatch(BookingActions.bookingsListRequest({}, 0))
    }
  }, [debouncedQueryValue])

  const onPrevious = () => {
    dispatch(
      BookingActions.bookingsListRequest(
        {
          search_term: queryValue,
        },
        listDataOffset - ItemsPerPage
      )
    )
  }

  const onNext = () => {
    dispatch(
      BookingActions.bookingsListRequest(
        {
          search_term: queryValue,
        },
        listDataOffset + ItemsPerPage
      )
    )
  }

  return (
    <div style={{ marginBottom: -10, position: 'relative', bottom: 20 }}>
      <div>
        <LegacyCard>
          {selected !== 2 && (
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                width: '100%',
              }}
            >
              <div style={{ width: '100%' }}>
                <LegacyCard.Section>
                  <LegacyFilters
                    queryValue={queryValue}
                    queryPlaceholder="Filter items by Product Name, Variant Name, Order No., Customer Name"
                    filters={filters}
                    appliedFilters={appliedFilters}
                    onQueryChange={handleFiltersQueryChange}
                    onQueryClear={handleQueryValueRemove}
                    onClearAll={handleFiltersClearAll}
                  />
                </LegacyCard.Section>
              </div>
            </div>
          )}
          {bookingsFetching ? (
            <Loader />
          ) : bookingsList.length > 0 || listDataOffset > 0 ? (
            <>
              <DataTable
                columnContentTypes={['text', 'text', 'text', 'numeric']}
                headings={headings}
                rows={bookings}
              />
              {selected !== 2 && (
                <AppointoPagination
                  offset={listDataOffset}
                  onPrevious={onPrevious}
                  list={bookings}
                  onNext={onNext}
                />
              )}
            </>
          ) : (
            <LegacyCard>
              <div
                style={{
                  display: 'flex',
                  height: 300,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                No Bookings. Please add an appointment or change the search term
                for the bookings to show up here
              </div>
            </LegacyCard>
          )}
        </LegacyCard>
      </div>
    </div>
  )
}

export default CustomerSettings
